import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

export const useAccountFetchedAndExists = () => {
	const accountExists = useVelocityAccountStore(
		(s) => Object.keys(s.accounts).length > 0
	);
	const hasLoadedAccounts = useVelocityAccountStore((s) => s.hasLoadedAccounts);

	return [hasLoadedAccounts, accountExists];
};
